function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M45.5331 0H15.4834C12.7213 0 10.4751 2.24898 10.4751 5.01446H40.5248C43.2869 5.01446 45.5331 7.26344 45.5331 10.0289V30.0868C48.2952 30.0868 50.5414 27.8378 50.5414 25.0723V5.01446C50.5414 2.24898 48.2952 0 45.5331 0Z",
  fill: "#74D6D6"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.4751 40.4099H5.46678C2.70471 40.4099 0.458496 38.161 0.458496 35.3955V15.3377C0.458496 12.5722 2.70471 10.3232 5.46678 10.3232H35.5165C38.2786 10.3232 40.5248 12.5722 40.5248 15.3377V35.3955C40.5248 38.161 38.2786 40.4099 35.5165 40.4099H23.2487L10.4751 50.6419V40.4099ZM11.4588 27.6087C13.1945 27.6087 14.6016 26.2016 14.6016 24.4658C14.6016 22.7301 13.1945 21.3229 11.4588 21.3229C9.72302 21.3229 8.31592 22.7301 8.31592 24.4658C8.31592 26.2016 9.72302 27.6087 11.4588 27.6087ZM24.0301 24.4658C24.0301 26.2016 22.6229 27.6087 20.8872 27.6087C19.1514 27.6087 17.7443 26.2016 17.7443 24.4658C17.7443 22.7301 19.1514 21.3229 20.8872 21.3229C22.6229 21.3229 24.0301 22.7301 24.0301 24.4658ZM30.3159 27.6087C32.0516 27.6087 33.4587 26.2016 33.4587 24.4658C33.4587 22.7301 32.0516 21.3229 30.3159 21.3229C28.5801 21.3229 27.173 22.7301 27.173 24.4658C27.173 26.2016 28.5801 27.6087 30.3159 27.6087Z",
  fill: "#EF5DA8"
});
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.3a1e893e.svg";
export { ForwardRef as ReactComponent };